import lodash from 'lodash';

import { Season } from 'types/api/seasons.type';

const useSeasons = (seasons: Season[], currentSeason: string) => {
  const seasonsSorted = lodash.groupBy(seasons, 'season');

  const linesList = Object.entries(seasonsSorted).map(([key, value]) => ({
    season: key,
    catalog: value.map((item) => item.descEng),
  }));

  const currentSeasonLines = linesList.find((line) => line.season === currentSeason);

  return {
    linesList,
    currentSeasonLines,
  };
};

export { useSeasons };
